import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthFacade } from '../../../../../../../auth/facade/auth.facade';
import { NbDialogRef } from '@nebular/theme';
import {Subscription} from "rxjs";
import {LocalStorageManagerService} from "../../../../../../../shared/services/local-storage-manager.service";

@Component({
  selector: 'morva-sutvey-dialog',
  templateUrl: './sutvey-dialog.component.html',
  styleUrl: './sutvey-dialog.component.scss'
})
export class SutveyDialogComponent implements OnInit, OnDestroy {
  dontShowAgain: boolean = false;
  userId: string;
  surveyUrl: SafeResourceUrl = '';
  private subscriptions:Subscription[] = []
  surveyDetails:any = {}
  options = [5,4,3,2,1]
  isLoading = false;
  validResponseCount = 0;
  answerCount = 0;
  constructor(
    private dialogRef: NbDialogRef<any>,
    private authFacade: AuthFacade,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadSurveyUrl();
    this.setListeners();
  }

  private setListeners(){
    this.subscriptions.push(this.authFacade.getSurveyDetails$().subscribe(res=>{
      this.surveyDetails = res;
      if(res){
        this.validResponseCount = this.surveyDetails?.questions?.filter((item)=>(item.questionType === 'Optional'))?.length
      }
    }))
  }

  loadSurveyUrl(): void {
    this.http.get<{ poolingSrc: string }>('/assets/surveySRC.json').subscribe(
      (data) => {
        console.log('Fetched survey URL:', data.poolingSrc);  // Debugging
        this.surveyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.poolingSrc);
      },
      (error) => {
        console.error('Error loading survey URL:', error);
      }
    );

  }

  closeDialog() {
    // if (this.dontShowAgain && this.userId) {
      // this.authFacade.setSurveyStatus(this.userId, true);
    // }
    LocalStorageManagerService.setItem(LocalStorageManagerService.surveyStatusKey, 'true');
    this.dialogRef.close();
  }

  onAnswerChange(){
    this.answerCount = this.surveyDetails?.questions?.filter((item)=>(item.questionType === 'Optional' && item.answer)).length
  }

  onSubmit(type: 'ignore'|'submit'){
    const payload = {
      surveyId: this.surveyDetails?.surveyId,
      answerType: (type==='submit'?1: 2),
      answers: this.surveyDetails?.questions?.map((item:any)=>{
        const {id, answer} = item;
        return {
          answer,
          id
        }
      })
    };
    this.authFacade.setSurveyStatus(payload);
    this.closeDialog();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item=>item.unsubscribe())
  }
}
